export const REGULATION_LIST_LOADING = 'REGULATION_LIST_LOADING';
export const REGULATION_LIST_FAILURE = 'REGULATION_LIST_FAILURE';
export const REGULATION_LIST_SUCCESS = 'REGULATION_LIST_SUCCESS';

export const REGULATION_LIST_SAVE_LOADING = 'REGULATION_LIST_SAVE_LOADING';
export const REGULATION_LIST_SAVE_FAILURE = 'REGULATION_LIST_SAVE_FAILURE';
export const REGULATION_LIST_SAVE_SUCCESS = 'REGULATION_LIST_SAVE_SUCCESS';
